import { render, staticRenderFns } from "./CashAdvance.vue?vue&type=template&id=c196eb12&"
import script from "./CashAdvance.vue?vue&type=script&lang=js&"
export * from "./CashAdvance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports